import React, { useEffect, useState } from "react";
import { Card, Form, Input, Button, message, Spin, Empty, Avatar } from "antd";
import { TeamOutlined } from "@ant-design/icons";
import { api } from "../api";
import ImageUpload from "../components/ImageUpload";

const MyGroupPage = () => {
    const [group, setGroup] = useState(undefined); // undefined=loading, null=none
    const [saving, setSaving] = useState(false);
    const [form] = Form.useForm();
    const image = Form.useWatch("image", form);

    useEffect(() => {
        api.myGroup()
            .then((r) => {
                setGroup(r.group);
                if (r.group) form.setFieldsValue(r.group);
            })
            .catch((e) => {
                message.error(e.message);
                setGroup(null);
            });
    }, [form]);

    const save = async () => {
        const values = await form.validateFields();
        setSaving(true);
        try {
            const updated = await api.updateMyGroup(values);
            setGroup(updated);
            message.success("Group updated");
        } catch (e) {
            message.error(e.message);
        } finally {
            setSaving(false);
        }
    };

    if (group === undefined) return <Spin size="large" style={{ marginTop: 80 }} />;
    if (!group)
        return (
            <Empty
                style={{ marginTop: 80 }}
                description="You don't have a group assigned yet."
            />
        );

    return (
        <div>
            <h1 className="admin-page-title">My Group</h1>
            <Card variant="borderless" style={{ maxWidth: 620 }}>
                <div style={{ textAlign: "center", marginBottom: 20 }}>
                    <Avatar size={88} src={image} icon={<TeamOutlined />} />
                </div>
                <Form form={form} layout="vertical">
                    <Form.Item name="image" label="Group avatar">
                        <ImageUpload />
                    </Form.Item>
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: "Name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item name="city" label="City">
                        <Input />
                    </Form.Item>
                    <Form.Item name="description" label="Description">
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <Button type="primary" loading={saving} onClick={save}>
                        Save changes
                    </Button>
                </Form>
            </Card>
        </div>
    );
};

export default MyGroupPage;
